import React from "react";

const NotificationSettingsSkeleton: React.FC = () => {
  return (
    <div className="relative pt-10 pb-14 px-14 max-md:p-0">
      <h2 className="skeleton w-2/4 min-h-6 !rounded-md mb-6 max-md:mb-4 max-md:w-1/3"></h2>
      <div className="max-h-[600px] overflow-auto max-md:max-h-full flex flex-col gap-6">
        <div className="flex items-center justify-between">
          <span className="skeleton w-2/3 min-h-6 !rounded-md text-primary text-xl"></span>
          <div className="skeleton w-12 h-6 !rounded-md"></div>
        </div>
        <div className="flex items-center justify-between">
          <span className="skeleton w-2/3 min-h-6 !rounded-md text-primary text-xl"></span>
          <div className="skeleton w-12 h-6 !rounded-md"></div>
        </div>
        <div className="flex items-center justify-between">
          <span className="skeleton w-2/3 min-h-6 !rounded-md text-primary text-xl"></span>
          <div className="skeleton w-12 h-6 !rounded-md"></div>
        </div>
        <div className="flex items-center justify-between">
          <span className="skeleton w-2/3 min-h-6 !rounded-md text-primary text-xl"></span>
          <div className="skeleton w-12 h-6 !rounded-md"></div>
        </div>
        <div className="flex items-center gap-3">
          <div className="skeleton w-6 h-6 rounded-full"></div>
          <span className="skeleton w-2/3 min-h-6 !rounded-md text-primary text-xl"></span>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettingsSkeleton;
